import createRoute    from '@widesk-ui/tools/createRoute';
import EventTypeModel from '@models/website/EventTypeModel';

const route = createRoute.dashboardFromModel(
	EventTypeModel,
	'EventTypeDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
